angular.module('product')
    .component('productList', {
        bindings: {
            page: '<',
            filters: '<',
            groups: '<'
        },
        templateUrl: 'app/product/list.html',
        controller: function ($scope, $state, $stateParams, Product, ProductGroup, ProductService, ProductSubstituteService) {
            this.ProductService = ProductService;
            this.ProductSubstituteService = ProductSubstituteService;

            this.reset = () => this.filters = {};
            this.refreshGroups = q => ProductGroup.list({search: q}).$promise.then(items => this.groups = items)

            $scope.$on('product.updated', () => $state.reload());
        }
    })
